import { PropsWithChildren, ReactElement, CSSProperties } from 'react';
import { BadgeStatus, statusColorMap } from '../badge-dot/BadgeDot';
import styles from './StatusCard.module.scss';

export interface StatusCardProps {
  status: BadgeStatus;
  colorMap?: Partial<Record<BadgeStatus, string>>; // Allow passing status colors overrides.
  width?: string; // CSS string
}

export const StatusCard = ({
  status,
  colorMap,
  width,
  children,
}: PropsWithChildren<StatusCardProps>): ReactElement => {
  const statusColor = colorMap?.[status] ?? statusColorMap[status];

  return (
    <div
      className={styles.card}
      style={{ '--dm-status-color': statusColor, '--dm-status-card-width': width } as CSSProperties}
    >
      {children}
    </div>
  );
};
